export default "__VITE_ASSET__BPq$QRYX__"